import { createSelector } from 'reselect';
import { RefundMode, VoluntaryReason } from '../types';
import { ExareReason, NASStatus } from '@websky/graphql';
import { getCustomer } from './customer/selectors';
import { getSelectedPassengersWithChildrenIds } from './passengers/selectors';
import { getSelectedReason } from './reason/selectors';
import { getRefundFiles } from './documents/selectors';
import { getNasServices } from './refundInfo/selectors';
import { getSelectedInsurancesByTypes } from '../../utils';
import { getAviaOrderStateHash } from './aviaOrder/selectors';
export const getState = (state) => state;
export const getOrder = createSelector(getState, state => state.aviaOrder);
export const getOrderId = createSelector(getState, state => state.aviaOrder.id);
export const getTravellers = createSelector(getOrder, order => order.travellers);
export const getRefundMode = createSelector(getState, state => state.mode);
export const isAutoRefundMode = createSelector(getRefundMode, getSelectedReason, (refundMode, reason) => {
    return reason.title === VoluntaryReason.Voluntary && refundMode === RefundMode.Auto;
});
export const getIsRefundVoluntary = createSelector(getState, state => !!ExareReason[state.reason.title]);
export const getRefundInfo = createSelector(getState, state => state.refundInfo);
export const getRefundPrices = createSelector(getRefundInfo, refundInfo => refundInfo.prices);
export const getRefundSeatReleaseMode = createSelector(getState, state => state.refundInfo.seatReleaseMode);
export const createGetCreateRefundParams = (orderId) => createSelector(getCustomer, getSelectedPassengersWithChildrenIds, isAutoRefundMode, getSelectedReason, getRefundFiles, getAviaOrderStateHash, getRefundInfo, (customer, selectedPassengersIds, isAutoRefundMode, selectedReason, refundFiles, orderStateHash, refundInfo) => {
    var _a, _b;
    if (!customer) {
        return null;
    }
    const isVoluntary = selectedReason.title === VoluntaryReason.Voluntary;
    const haveUnvoluntaryReasons = ((_a = refundInfo.unvoluntaryReasonsInfo) === null || _a === void 0 ? void 0 : _a.length) > 0;
    return {
        orderId: orderId,
        isCompelled: !isVoluntary && haveUnvoluntaryReasons,
        passengers: selectedPassengersIds,
        email: customer.email,
        name: customer.name,
        phone: customer.phone,
        comment: (_b = customer.comments) !== null && _b !== void 0 ? _b : '',
        files: isVoluntary ? [] : refundFiles,
        reason: isVoluntary ? null : selectedReason.title,
        orderStateHash
    };
});
export const isNasServiceRefundRequired = createSelector([getNasServices], nas => {
    var _a, _b;
    return (_b = (_a = nas === null || nas === void 0 ? void 0 : nas.selectedServices) === null || _a === void 0 ? void 0 : _a.some(selected => selected.orders.some(order => order.status === NASStatus.Confirmed && order.isRefundable))) !== null && _b !== void 0 ? _b : false;
});
export const getSelectedInsurancesByType = (insuranceType) => createSelector(getOrder, order => { var _a, _b, _c; return getSelectedInsurancesByTypes((_c = (_b = (_a = order === null || order === void 0 ? void 0 : order.additionalServices) === null || _a === void 0 ? void 0 : _a.insurances) === null || _b === void 0 ? void 0 : _b.selectedInsurances) !== null && _c !== void 0 ? _c : [], [insuranceType]); });
export const getGdsServicesRefundInfo = createSelector(getState, state => state.gdsServicesRefundInfo);
export const getSelectedInsurances = createSelector(getOrder, order => { var _a, _b; return (_b = (_a = order.additionalServices) === null || _a === void 0 ? void 0 : _a.insurances) === null || _b === void 0 ? void 0 : _b.selectedInsurances; });
